import LoadingScreen from './LoadingScreen';

export default LoadingScreen;